import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import EmailSeries from './icon-email-series.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <EmailSeries {...validProps} />;
}
SvgComponent.iconName = 'emailSeries';

/**
 * @deprecated This is a legacy icon
 */
export const EmailSeriesIcon = svgIconWrapper(SvgComponent);
